import { UserJson, UserType, UserOrg, IBaseUserBuilder } from '@nab/x-types';
import { BaseUser } from './BaseUser';

export abstract class BaseUserBuilder<T extends BaseUser> implements IBaseUserBuilder<T> {
    protected json: UserJson;

    constructor(user?: T | UserJson) {
        /**
         * If existing user object needs to be changed.
         * The object can be based as part of the builder to copy the properties.
         */
        if (user && (user as T).toJSON) {
            this.json = (user as T).toJSON();
        } else {
            /**
             * If user already has the User information they can pass on the JSON to create the user object.
             */
            this.json = user || <UserJson>{};
        }
    }

    public id(id: string, idHash: string): BaseUserBuilder<T> {
        this.json.id = id;
        this.json.idHash = idHash;
        return this;
    }

    public authenticated(value: boolean): BaseUserBuilder<T> {
        this.json.authenticated = value;
        return this;
    }

    public userType(value: UserType): BaseUserBuilder<T> {
        this.json.type = value;
        return this;
    }

    public userOrg(value: UserOrg): BaseUserBuilder<T> {
        this.json.org = value;
        return this;
    }

    public details(value: { [key: string]: any }): BaseUserBuilder<T> {
        this.json.details = value;
        return this;
    }

    public context(value: { [key: string]: any }): BaseUserBuilder<T> {
        this.json.context = value;
        return this;
    }

    public actAs(value: UserJson): BaseUserBuilder<T> {
        this.json.as = value;
        return this;
    }

    public abstract build(): T;
}
